import { get } from './api';

function suggestionsSort(a, b) {
    switch (true) {
        case a.order < b.order:
            return -1;
        case a.order > b.order:
            return 1;
        case a.name < b.name:
            return -1;
        case a.name > b.name:
            return 1;
        default:
            return 0;
    }
}

export function fetchFileTypes() {
    return get('common/fileTypes');
}

export function fetchOrgTypes() {
    return get('common/opfs').then((res) => {
        const data = res.data
            .map((item) => ({
                ...item
            }));

        return {
            ...res,
            data,
        };
    });
}

export function fetchRegions() {
    return get('common/regions').then((res) => {
        const data = res.data
            .map((item) => ({
                ...item,
                id: item.code,
                name: item.name.trim(),
            }));

        return {
            ...res,
            data,
        };
    });
}

export function fetchEdoTypes() {
    return get('common/edoTypes').then((res) => {
        const data = res.data
            .reduce((edoTypes, item) => {
                edoTypes[item.id] = item.name.trim();
                return edoTypes;
            }, {});

        return {
            ...res,
            data,
        };
    });
}

export function fetchContractStatuses() {
    return get('common/contractStatuses');
}

export function fetchContractTypes() {
    return get('common/contractTypes');
}



// WEBPACK FOOTER //
// ./src/services/api/common.js